import React from "react";
import { Box, useTheme } from "@mui/material";

interface Props {
  jumpToNavigationString: string;
}

const BNJumpToNavigation: React.FC<Props> = (props) => {
  const theme = useTheme();
  return (
    <Box
      component="a"
      href="#MainContent"
      sx={{
        position: "absolute",
        overflow: "hidden",
        fontSize: "2rem",
        clip: "rect(0.1rem, 0.1rem, 0.1rem, 0.1rem)",
        width: "0.1rem",
        height: "0.1rem",
        wordWrap: "normal",
        display: "block",
        padding: "0.8rem",
        textAlign: "center",
        textDecoration: "none",
        color: "secondary.light",
        backgroundColor: "tertiary.darker",
        outline: "none",
        fontWeight: "bold",
        "&:focus": {
          position: "static",
          overflow: "visible",
          clip: "auto",
          width: "auto",
          height: "auto",
          "& span": {
            zIndex: "100",
            outline: `0.3rem solid ${theme.vars.palette.primary.main}`,
            outlineOffset: "0.2rem",
            transition: "none",
            textDecoration: "none",
          },
        },
      }}
      onClick={() => {
        document?.getElementById("MainContent")?.focus();
      }}
    >
      <span>{props.jumpToNavigationString}</span>
    </Box>
  );
};

export default BNJumpToNavigation;
